// extracted by mini-css-extract-plugin
module.exports = {"Backdrop":"ComponentBackdrop_Backdrop__Yeo90"};